import { GET_POOL_REWARDS_STATS } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case GET_POOL_REWARDS_STATS:
      return action.payload;
    default:
      return state;
  }
};
